require([
    'services',
    'semantic',
    'ch_header',
    'ch_menu',
    'jquery',
    'ch_semantic_responsive',
    'curtain',
    'ytPlayer',
    'ch_scrollto'
], function() {
    // Page scope variables
    var $currentNavIcon = null;
    var $currentSlide = null;
    var $navigationList = $('.navigation');
    var $slideList = $('ol');
    var $navigationCircleIcons = $('.circle.icon');
    var scrollToHeight = 0;

    // Updates navigation icons colors
    function updateNavigationIcons($elem) {
        $navigationCircleIcons.removeClass('grey').addClass('white');
        $elem.addClass('grey');
    }

    // Callback from curtain.js that handles events when a new curtain is displayed
    // in the view
    function handleCurtainScrolling() {
        $currentSlide = $slideList.find('.current');
        $currentNavIcon = $navigationList.find("[data-icon-index='" + $currentSlide.attr('data-slide-index') + "']");
        updateNavigationIcons($currentNavIcon);
    }

    // Handles navigation when clicking in circle icons
    function handleNavigationScrolling($elem) {
        $currentSlide = $slideList.find("[data-slide-index=" + $elem.attr('data-icon-index') + "]");
        // Scroll to next slide
        scrollToHeight = $currentSlide.attr('data-position');
        CH.scrollTo(scrollToHeight);
        // Update the navigation icons to match current slide selection
        updateNavigationIcons($elem);
    }

    function initBindEvents() {
        // Event when clicking on navigation circle icons
        $navigationCircleIcons.on('click', function() {
            handleNavigationScrolling($(this));
        });

        $('.angle.down.icon').on('click', function() {
            handleNavigationScrolling($navigationList.find("[data-icon-index=2]"));
        });
    }

    function init() {
        // Initialize curtains
        $('.curtains').curtain({
            scrollSpeed: 300,
            nextSlide: handleCurtainScrolling,
            prevSlide: handleCurtainScrolling
        });

        // Only applicable for desktop since in mobile playing youtube video
        // using this jquery library is currently not supported
        if (!CH.isMobile) {
            // Initialize player
            // NOTE: set pause on scrolling to true so that rendering is smooth
            $('#video-container').YTPlayer({
                fitToBackground: false,
                videoId: 'J-p86veCKHo',
                pauseOnScroll: true
            });
        }

        // Bind event handler used for scrolling navigation
        initBindEvents();
    }

    $(function() {
        init();
    });
});

